import { AgResourceLanguage } from '../types';

export const sharedComponents: AgResourceLanguage['sharedComponents'] = {
  outOfStock: 'Nicht vorrätig',
  comingSoon: 'Demnächst',
  button: {
    cancel: 'Zurück',
    delete: 'Löschen',
    remove: 'Entfernen'
  },
  supportCard: {
    title: 'Du brauchst Hilfe bei deiner Bestellung?',
    description: 'Weitere Infos findest du in den',
    linkFAQ: 'FAQs',
    email: 'support.eu@drinkag1.com',
    phone: '+49 800 7234944',
    phoneHref: '+498007234944'
  },
  paymentInfoBackGuarantee: {
    label: '90-Day Money Back Guarantee',
    description: 'If you don’t love your AG1 within the first 90 days, it’s on is.'
  },
  paymentInfoCancelAnytime: {
    label: 'Pause, Change or Cancel Anytime',
    description: 'Adjust your subscription as your needs change. You’re in control.'
  },
  promoCode: {
    promoButtonLabel: 'Anwenden',
    promoCTA: 'Hast Du einen Promo-Code?',
    promoError: 'Code ist nicht gültig.',
    promoInputLabel: 'Promo-Code'
  },
  summaryCheckout: {
    discountLabel: 'Dein Rabatt',
    freePrice: 'Kostenlos',
    shippingLabel: 'Versand',
    subtotalLabel: 'Zwischensumme',
    taxEstimatedLabel: 'Estimated Tax',
    taxLabel: 'MwSt.',
    taxNotReady: '---',
    totalLabel: 'Gesamt',
    shippingExpectedPrice: 'Kostenlos'
  },
  addressForm: {
    firstName: 'Vorname*',
    lastName: 'Nachname*',
    country: 'Land/Region*',
    addressLine1: 'Adresse',
    addressLine2: 'Wohnung, Zimmer usw.',
    city: 'Stadt',
    province: 'Bundesstaat',
    zipCode: 'PLZ',
    phone: 'Telefon',
    company: 'Firma',
    optional: 'optional'
  },
  // MODAL CONTENT
  editShippingAddress: {
    headerEdit: 'Versandadresse bearbeiten',
    headerCreate: 'Lieferadresse hinzufügen',
    headerSelect: 'Versandadresse auswählen',
    reloadMessage: 'Bitte Seite neu laden',
    titleEditAddress: 'Adressinformationen',
    usedSavedLabel: 'Gespeicherte Adresse verwenden',
    useSavedAddressText: 'Bitte wähle eine Lieferadresse aus',
    noSavedAddressText: 'Aktuell sind keine gespeicherten Adressen vorhanden.',
    useSavedAddressButton: 'Gespeicherte Adresse verwenden',
    noSavedAddressButton: 'Keine gespeicherten Adressen',
    defaultAddress: 'Standardadresse:',
    defaultAddressText: 'This address is used on your subscription.',
    otherAddresses: 'Weitere Adressen',
    cancelEditButton: 'Zurück',
    updateEditButton: 'Aktualisieren',
    saveButton: 'Speichern',
    cancelSelectButton: 'Zurück',
    updateSelectButton: 'Ausgewählte verwenden',
    submitSelectButton: 'Ok',
    massUpdate: 'Bei allen aktiven Abos verwenden',
    subscriptionUpdate: 'Als Lieferadresse für mein Abonnement festlegen',
    giftTitle: 'Als Geschenk senden',
    giftRecipientEmailLabel: 'Empfänger-E-Mail',
    giftMessageLabel: 'Schreibe eine Nachricht zum Geschenk',
    giftAddressClosingAlert: {
      title: 'Close Recipient Shipping Address',
      content:
        'Are you sure you want to close shipping address without update? Your gift will be sent to your default address',
      editAddressButton: 'Edit address',
      confirmButton: 'Confirm'
    }
  },
  acceptDeleteAddress: {
    titleHeader: 'Adresse löschen',
    description: 'Möchten Sie diese Gespeicherte Adresse wirklich entfernen?',
    cancelButton: 'Zurück',
    deleteButton: 'Löschen'
  },
  addressVerified: {
    title: 'Bestätige deine Adresse',
    text: 'Wir konnten die von dir eingegebene Adresse nicht genau überprüfen. Bitte vergewissere dich, dass sie korrekt ist oder nimm die notwendigen Änderungen vor.',
    suggested: 'Vorgeschlagene Adresse',
    entered: 'Eingegebene Adresse',
    edit: 'Adresse bearbeiten',
    continue: 'Speichern fortsetzen'
  },
  giftLabel: {
    short: 'Gift',
    long: 'Your Gift'
  },
  v53: {
    originalFlavorTitle: 'Original',
    upgradedFormulaText: 'VERBESSERTE FORMEL',
    preferredFlavorText: 'MEMBER PREFERRED FLAVOR',
    selectFlavorText: 'Geschmack Auswählen',
    discardChanges: {
      title: 'Unsaved Changes',
      text: 'Do want to save the changes you made to your subscription?',
      save: 'Save Changes',
      discard: 'Discard Changes'
    }
  }
};
